import React, { useState } from 'react';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const AISummary = ({ summary, list }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div>
      <h4 style={{ textTransform: 'uppercase' }}>
        {t('progress.report_card.recap')}
      </h4>
      <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
        {t('progress.report_card.recap_description')}
      </Text>
      <TabbedView onSelect={setTabIndex} selectedIndex={tabIndex}>
        <TabList>
          <Tab>Summary</Tab>
          <Tab>List</Tab>
        </TabList>
        <TabPanel>
          <div className="mb-24 mt-8">{summary}</div>
        </TabPanel>
        <TabPanel>
          <div
            className="mb-16 mt-8 pl-24"
            dangerouslySetInnerHTML={{ __html: list }}
          />
        </TabPanel>
      </TabbedView>
      <hr />
    </div>
  );
};

export default AISummary;
